/* import __COLOCATED_TEMPLATE__ from './billing-and-payments-tabs.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './billing-and-payments-tabs.module.scss';

@classic
@classNames(styles.component)
export default class SiteBillingBillingAndPaymentsTabs extends Component {
  @service currentPractice;
  @service clientInsuranceAccess;
}
